import type { Location } from '../api/types';

export async function getLocation(): Promise<Location> {
  const pos = await new Promise<GeolocationPosition>((resolve, reject) => {
    if (!navigator.geolocation) reject(new Error('Geolocalizzazione non supportata'));
    navigator.geolocation.getCurrentPosition(resolve, reject, { enableHighAccuracy: true, timeout: 15000 });
  });

  const loc: Location = {
    lat: pos.coords.latitude,
    lon: pos.coords.longitude,
    accuracy: pos.coords.accuracy
  };

  // reverse geocode best-effort (OSM Nominatim)
  try {
    const url = new URL('https://nominatim.openstreetmap.org/reverse');
    url.searchParams.set('format', 'json');
    url.searchParams.set('lat', String(loc.lat));
    url.searchParams.set('lon', String(loc.lon));
    url.searchParams.set('zoom', '18');
    const r = await fetch(url.toString(), { headers: { 'Accept': 'application/json' } });
    if (r.ok) {
      const j = await r.json();
      if (j?.display_name) loc.address = String(j.display_name);
    }
  } catch (_) {}

  return loc;
}

export function locationHelpText() {
  return `Per timbrare è necessario consentire la posizione. Apri le impostazioni del browser e abilita “Consenti sempre”.`;
}
